export default "__VITE_ASSET__7ae4b64b__"